import { Role } from '../enums/role.enum';
export const Permissions = {
  PRODUCT_VIEW: 'product:view',
  PRODUCT_CREATE: 'product:create',
  PRODUCT_UPDATE: 'product:update',
  PRODUCT_DELETE: 'product:delete',
  ORDER_VIEW: 'order:view',
  ORDER_CREATE: 'order:create',
  ORDER_UPDATE: 'order:update',
  ORDER_CANCEL: 'order:cancel',
  INVENTORY_VIEW: 'inventory:view',
  INVENTORY_IMPORT: 'inventory:import',
  INVENTORY_EXPORT: 'inventory:export',
  INVENTORY_TRANSFER: 'inventory:transfer',
  INVENTORY_COUNT: 'inventory:count',
  POS_SELL: 'pos:sell',
  POS_VOID: 'pos:void',
  POS_DISCOUNT: 'pos:discount',
  POS_SHIFT_OPEN: 'pos:shift_open',
  POS_SHIFT_CLOSE: 'pos:shift_close',
  CUSTOMER_VIEW: 'customer:view',
  CUSTOMER_CREATE: 'customer:create',
  REPORT_VIEW: 'report:view',
  SETTINGS_MANAGE: 'settings:manage',
  // EG-332 — Settings sub-permissions (Owner-only by default)
  SETTINGS_VIEW: 'settings:view',
  SETTINGS_BUSINESS_MANAGE: 'settings:business_manage',
  SETTINGS_PAYMENT_MANAGE: 'settings:payment_manage',
  SETTINGS_BANK_ACCOUNTS_MANAGE: 'settings:bank_accounts_manage',
  SETTINGS_EINVOICE_MANAGE: 'settings:einvoice_manage',
  SETTINGS_NOTIFICATIONS_MANAGE: 'settings:notifications_manage',
  SETTINGS_API_KEYS_MANAGE: 'settings:api_keys_manage',
  SETTINGS_AUDIT_LOG_VIEW: 'settings:audit_log_view',
  BILLING_MANAGE: 'billing:manage',
  // EG — Pricing config (Plan 0 / pricing-config-tabs)
  PRICING_SOURCES_MANAGE: 'pricing:sources_manage',
  CURRENT_QUOTES_VIEW: 'current_quotes:view',
  CURRENT_QUOTES_UPDATE: 'current_quotes:update',
  INSTRUMENTS_VIEW: 'instruments:view',
  INSTRUMENTS_MANAGE: 'instruments:manage',
  PRICING_ATTRIBUTE_MAPPING_MANAGE: 'pricing:attribute_mapping_manage',
  FEE_GROUPS_VIEW: 'fee_groups:view',
  FEE_GROUPS_MANAGE: 'fee_groups:manage',
  PRICING_SPREAD_MANAGE: 'pricing:spread_manage',
  // EG-350 P2.6 — Commission module (port từ ancarat-bo)
  COMMISSION_VIEW_ALL: 'commission:view_all',
  COMMISSION_CONFIG_MANAGE: 'commission:config_manage',
  COMMISSION_SPLITS_MANAGE: 'commission:splits_manage',
  COMMISSION_RATES_MANAGE: 'commission:rates_manage',
  COMMISSION_ROLES_MANAGE: 'commission:roles_manage',
  COMMISSION_LIVE_SESSIONS_MANAGE: 'commission:live_sessions_manage',
  COMMISSION_APPROVE: 'commission:approve',
  COMMISSION_ADJUSTMENTS_MANAGE: 'commission:adjustments_manage',
  // Sales module — ancarat sales:*
  SALES_DASHBOARD_ALL: 'sales:dashboard_all',
  SALES_DASHBOARD_OWN: 'sales:dashboard_own',
  SALES_LEADERBOARD: 'sales:leaderboard',
  SALES_TARGET_SET: 'sales:target_set'
};
export const RolePermissions = {
  [Role.OWNER]: Object.values(Permissions),
  [Role.MANAGER]: [Permissions.PRODUCT_VIEW, Permissions.PRODUCT_CREATE, Permissions.PRODUCT_UPDATE, Permissions.PRODUCT_DELETE, Permissions.ORDER_VIEW, Permissions.ORDER_CREATE, Permissions.ORDER_UPDATE, Permissions.ORDER_CANCEL, Permissions.INVENTORY_VIEW, Permissions.INVENTORY_IMPORT, Permissions.INVENTORY_EXPORT, Permissions.INVENTORY_TRANSFER, Permissions.INVENTORY_COUNT, Permissions.POS_SELL, Permissions.POS_VOID, Permissions.POS_DISCOUNT, Permissions.POS_SHIFT_OPEN, Permissions.POS_SHIFT_CLOSE, Permissions.CUSTOMER_VIEW, Permissions.CUSTOMER_CREATE, Permissions.REPORT_VIEW,
  // Manager: read-only Settings (xem business info / payment / einvoice config)
  Permissions.SETTINGS_VIEW,
  // Manager: see all commission, manage live sessions + sales target
  Permissions.COMMISSION_VIEW_ALL, Permissions.COMMISSION_LIVE_SESSIONS_MANAGE, Permissions.SALES_DASHBOARD_ALL, Permissions.SALES_LEADERBOARD, Permissions.SALES_TARGET_SET, Permissions.PRICING_SOURCES_MANAGE, Permissions.CURRENT_QUOTES_VIEW, Permissions.CURRENT_QUOTES_UPDATE, Permissions.INSTRUMENTS_VIEW, Permissions.INSTRUMENTS_MANAGE, Permissions.PRICING_ATTRIBUTE_MAPPING_MANAGE, Permissions.FEE_GROUPS_VIEW, Permissions.FEE_GROUPS_MANAGE, Permissions.PRICING_SPREAD_MANAGE],
  [Role.CASHIER]: [Permissions.POS_SELL, Permissions.POS_VOID, Permissions.POS_DISCOUNT, Permissions.ORDER_VIEW, Permissions.ORDER_CREATE, Permissions.PRODUCT_VIEW, Permissions.CUSTOMER_VIEW, Permissions.CUSTOMER_CREATE,
  // Cashier: chỉ xem HH cá nhân + leaderboard
  Permissions.SALES_DASHBOARD_OWN, Permissions.SALES_LEADERBOARD, Permissions.CURRENT_QUOTES_VIEW, Permissions.INSTRUMENTS_VIEW, Permissions.FEE_GROUPS_VIEW],
  [Role.INVENTORY]: [Permissions.INVENTORY_VIEW, Permissions.INVENTORY_IMPORT, Permissions.INVENTORY_EXPORT, Permissions.INVENTORY_TRANSFER, Permissions.INVENTORY_COUNT, Permissions.PRODUCT_VIEW, Permissions.INSTRUMENTS_VIEW, Permissions.CURRENT_QUOTES_VIEW],
  [Role.VIEWER]: [Permissions.PRODUCT_VIEW, Permissions.ORDER_VIEW, Permissions.INVENTORY_VIEW, Permissions.REPORT_VIEW, Permissions.COMMISSION_VIEW_ALL, Permissions.SALES_DASHBOARD_ALL, Permissions.SALES_LEADERBOARD, Permissions.CURRENT_QUOTES_VIEW, Permissions.INSTRUMENTS_VIEW]
};
//# sourceMappingURL=permissions.js.map